// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Sidebar_wrapper__x7sGz","newCollection":"Sidebar_newCollection__2s0r3"};